import { PButtonPure } from '@porsche-design-system/components-react';
import styled from 'styled-components';

/*
    The styling below currently for prevent misplacement on subheader and 
    this styling is only applied there since it has position: absolute,
    for the other implementation is fine 
*/

const StyledPButtonPure = styled(PButtonPure)`
    top: 10px !important;
`;

const CloseButton = props => <StyledPButtonPure {...props} icon="close" type="button" />;

export default CloseButton;
